import '../reset.css';
import '../style.css';
import '../styles/mycs.css';
import {userBrowserId} from '../scripts/common.js';
import './my_katex.js';
import 'highlight.js/styles/github.css';
import {initIframeResize} from './_inIFrame.js';


import hljs from 'highlight.js/lib/core';
import python from 'highlight.js/lib/languages/python';
import cpp from 'highlight.js/lib/languages/cpp';
import java from 'highlight.js/lib/languages/java';
import javascript from 'highlight.js/lib/languages/javascript';
import kotlin from 'highlight.js/lib/languages/kotlin';
import php from 'highlight.js/lib/languages/php';
import go from 'highlight.js/lib/languages/go';
import ruby from 'highlight.js/lib/languages/ruby';
import rust from 'highlight.js/lib/languages/rust';
import csharp from 'highlight.js/lib/languages/csharp';
import delphi from 'highlight.js/lib/languages/delphi';

initIframeResize();

hljs.registerLanguage('python', python);
hljs.registerLanguage('cpp', cpp);
hljs.registerLanguage('java', java);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('kotlin', kotlin);
hljs.registerLanguage('php', php);
hljs.registerLanguage('go', go);
hljs.registerLanguage('ruby', ruby);
hljs.registerLanguage('rust', rust);
hljs.registerLanguage('csharp', csharp);
hljs.registerLanguage('pascal', delphi);





const copyToClipboard = (ev) => {
  let $el = ev.target;
  // Ищем предка, у которого стоит data-атрибут copyit
  while ($el && $el.dataset.copyit !== '1') $el = $el.parentNode;
  if (!$el) return;
  const pixelWidth = parseFloat(getComputedStyle($el).fontSize);
  const coords = $el.getBoundingClientRect();
  if (ev.clientY < coords.top + pixelWidth * 1.2 + 10) { // см. стили .input:before
    const text = $el.innerText.replace(/^\n+/, '');
    navigator.clipboard.writeText(text)
             .then(() => {
               // Чтобы показать успех, заменим значок копирования на 300мс
               const $dv = document.createElement('div');
               $dv.style.position = 'fixed';
               $dv.style.left = parseInt((coords.left + coords.right) / 2 + pixelWidth * 1.7) + 'px';
               $dv.style.top = (coords.top - pixelWidth * 1.5) + 'px';
               $dv.style.color = 'green';
               $dv.innerText = '✔ copied';
               document.body.appendChild($dv);
               setTimeout(($dv) => document.body.removeChild($dv), 400, $dv);
             });
  }
};
const createInputOuputListeners = () => {
  for (const $el of document.querySelectorAll(".input, .output, .optionAns, .comment, .pyVS, .bashVS, .cppVS, .jsVS, .justblock, .sqlVS, .rustVS")) {
    $el.addEventListener("click", copyToClipboard);
    $el.dataset.copyit = '1';
  }
};

const runSyntaxHighlighting = () => {
  for (let lang of ['python', 'cpp', 'tex', 'sql', 'js', 'rust', 'bash', 'pyVS', 'bashVS', 'cppVS', 'jsVS', 'sqlVS', 'rustVS']) {
    for (let $code of document.getElementsByClassName(lang)) {
      if (lang.endsWith('VS')) {
        lang = lang.slice(0, -2);
        if (lang === 'py') lang = 'python';
        if (lang === 'js') lang = 'javascript';
      }
      $code.innerHTML = hljs.highlight($code.innerText, {language: lang, ignoreIllegals: true}).value;
    }
  }
};

const init = () => {
  createInputOuputListeners();
  runSyntaxHighlighting();
  hljs.highlightAll();
};

const onDOMContentLoaded = () => {
  init();
};
document.addEventListener("DOMContentLoaded", onDOMContentLoaded);

